import SvgIcon from '@home/components/SvgIcon';
import EmailInput from '@op/components/EmailInput';
import React, { useMemo } from 'react';
import { Form, Input } from 'tea-component';
import { useIntl } from 'umi';

type GPTSummaryMultiNameFormType = {
  name: {
    name: string;
    name_cn: string;
  };
  setName: (value: string, key?: string) => void;
  emailList: Array<string>;
  setEmailList: (value: Array<string>) => void;
  showEmailMessage: boolean;
  setShowEmailMessage: (value: boolean) => void;
  placeholder?: string;
  isFirst?: boolean;
};

export function GPTSummaryMultiNameForm({
  needSummaryName,
  name,
  setName,
  emailList,
  setEmailList,
  setShowEmailMessage,
  showEmailMessage,
  placeholder,
  isFirst = false,
}: GPTSummaryMultiNameFormType & {
  needSummaryName?: boolean;
}) {
  const { formatMessage } = useIntl();
  const { name: nameEN, name_cn: nameCN } = name;
  const error = useMemo(() => {
    if (isFirst) {
      return null;
    }
    if (!nameEN.trim()) {
      return formatMessage({ id: "Can't be null" });
    }

    return null;
  }, [nameEN, isFirst, formatMessage]);

  if (!needSummaryName) return null;

  return (
    <>
      <Form.Item
        required
        showStatusIcon={false}
        label={formatMessage({ id: 'Summary Name EN' })}
        className="dbo-aigc-radio-wrapper"
        status={error ? 'error' : undefined}
        message={error}
      >
        <Input
          size="full"
          value={nameEN}
          onChange={(value) => setName(value)}
          placeholder={placeholder || formatMessage({ id: 'Please enter a name for report' })}
        />
        {
          nameEN !== '' && (
            <SvgIcon type={'clear-icon'} className='dbo-aigc-radio-wrapper-clear-icon' onClick={() => setName('')} />
          )
        }
      </Form.Item>
      <Form.Item
        showStatusIcon={false}
        label={formatMessage({ id: 'Summary Name CN' })}
        className="dbo-aigc-radio-wrapper"
        status={error ? 'error' : undefined}
        message={error}
      >
        <Input
          size="full"
          value={nameCN}
          onChange={(value) => setName(value, 'name_cn')}
          placeholder={placeholder || formatMessage({ id: 'Please enter a name for report' })}
        />
        {
          nameCN !== '' && (
            <SvgIcon type={'clear-icon'} className='dbo-aigc-radio-wrapper-clear-icon' onClick={() => setName('', 'name_cn')} />
          )
        }
      </Form.Item>
      {/* <Form.Item
        showStatusIcon={false}
        label={formatMessage({ id: 'Receiver Email' })}
        className="dbo-aigc-radio-wrapper"
        message={
          showEmailMessage
            ? formatMessage({ id: 'Please enter the correct email address' })
            : ''
        }
        status={showEmailMessage ? 'error' : undefined}
      >
        <EmailInput
          value={emailList}
          placeholder={formatMessage({
            id: 'The report will be sent to this email automatically upon generation',
          })}
          onChange={(tags, isError) => {
            setEmailList(tags);
            setShowEmailMessage(isError);
          }}
        />
      </Form.Item> */}
    </>
  );
}
